import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import PersonalBelongingList from "../pages/Phase-04/PersonalBelonging/PersonalBelongingsList";
import { selectHasPermission } from "../store/slices/authSlice";
import { fetchPersonalBelongings } from "../store/slices/personalBelongingsSlice";

const PersonalBelongings = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { personalBelongings, isLoading, error } = useSelector(
        (state) => state.personalBelongings
    );

    const canManageBelongings = useSelector((state) =>
        selectHasPermission(state, "belongings-manage")
    );
    const canCreateBelongings = useSelector((state) =>
        selectHasPermission(state, "belongings-create")
    );
    const canEditBelongings = useSelector((state) =>
        selectHasPermission(state, "belongings-edit")
    );
    const canDeleteBelongings = useSelector((state) =>
        selectHasPermission(state, "belongings-delete")
    );

    useEffect(() => {
        dispatch(fetchPersonalBelongings());
    }, [dispatch]);

    const handleAddBelonging = () => navigate("/phase04/personal-belongings/add");
    const handleEditBelonging = (id) => navigate(`/phase04/personal-belongings/edit/${id}`);

    const handleDeleteBelonging = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this record?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            // you can dispatch(deletePersonalBelonging(id)) here
            Swal.fire("Deleted!", "Record has been deleted.", "success");
        }
    };

    if (!canManageBelongings) {
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage personal belongings." }}
                replace
            />
        );
    }

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <PersonalBelongingList
                                belongings={personalBelongings}
                                onEditBelonging={canEditBelongings ? handleEditBelonging : null}
                                onDeleteBelonging={canDeleteBelongings ? handleDeleteBelonging : null}
                                onAddBelonging={canCreateBelongings ? handleAddBelonging : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default PersonalBelongings;
